import { LinearProgress } from '@mui/material';

export const tutorSlotUtilizationTableHead = ({ type }) => [
  {
    field: type ? 'syllabus_name' : 'subject_name',
    headerName: 'Category',
    width: 250,
  },
  {
    field: 'assigned_slots',
    headerName: 'Assigned Slots',
    width: 200,
  },
  {
    field: 'available_slots',
    headerName: 'Available Slots',
    width: 200,
  },
  {
    field: 'utilization_percentage',
    headerName: 'Utilization',
    width: 150,
    renderCell: ({ value }) => (
      <div style={{ display: 'flex', gap: '10px', flexDirection: 'row', width: '100%', alignItems: 'center' }}>
        <div style={{ width: '100%' }}>
          <p>{value}</p>
        </div>
        <div style={{ width: '100%' }}>
          <LinearProgress
            variant="determinate"
            value={Number(value?.split(' ')?.[0])}
            sx={{
              height: 8,
              borderRadius: 5,
              backgroundColor: '#E5E7EB',
              '& .MuiLinearProgress-bar': {
                backgroundColor: value > 80 ? '#FB2C36' : '#0068C2',
                borderRadius: 5,
              },
            }}
          />
        </div>
      </div>
    ),
  },
];
